/**
 * `setMutationDefaults` for non-outbox mutations: the one place a feature
 * registers them.
 *
 * A registration is what lets a PAUSED mutation resume after a restart: the
 * persisted cache stores the mutation's key and variables, never its function,
 * and on restore TanStack looks the function up here by `mutationKey`. Without
 * one, a mutation paused offline is restored and can never run.
 *
 * The workout's session and set writes are NOT registered here and must not
 * be: they go through the outbox (`outbox-runner.ts`), which survives a bundle
 * change and replays in order. Empty until a feature needs it.
 */
import type { AuthorizedFetcher } from "@repo/client/data/core";
import type { QueryClient } from "@tanstack/react-query";
import { registerSorenessMutationDefaults } from "../features/today/soreness-mutation";
import { registerFeedbackMutationDefaults } from "../features/workout/after/feedback-mutation";

export function registerMutationDefaults(
  client: QueryClient,
  api: AuthorizedFetcher
): void {
  // Post-workout feedback (T55): a paused feedback write must resume after a
  // restart, so its function is registered by key here.
  registerFeedbackMutationDefaults(client, api);
  // Today's soreness check-in (T41), for the same reason: answered offline,
  // it is restored paused and needs its function back before it can go out.
  registerSorenessMutationDefaults(client, api);
}
